/* eslint-disable react/no-multi-comp */
import React, {Component, Fragment} from 'react';
import {
    AutocompleteArrayInput,
    BulkDeleteButton,
    downloadCSV,
    Filter,
    FunctionField,
    List,
    NumberInput,
    Pagination,
    ReferenceInput,
    SelectInput,
    TextField,
    DateField,
    TextInput,
    translate
} from 'react-admin';
import {publicationStatusChoices} from '~constants/fieldGroups';
import {parse} from 'json2csv';

import CustomDatagrid from '~components/CustomDatagrid';
import {IirsaCountriesService} from '~config/services/iirsa_countries.service';

// Catalog filters are plain single-selects over the catalog endpoints.
const CatalogFilter = ({reference, ...props}) => (
    <ReferenceInput {...props} reference={reference} perPage={200} sort={{field: 'nombre', order: 'ASC'}}>
        <SelectInput optionText="name"/>
    </ReferenceInput>
);

class ActionFilter extends Component {
    state = {countries: []};

    constructor() {
        super();
        new IirsaCountriesService().get_la().then(r => this.setState({countries: r.data}));
    }

    render() {
        return (
            <Filter {...this.props}>
                <TextInput source="code" label="Código"/>
                <TextInput source="name" label="Nombre"/>
                <CatalogFilter source="territory" reference="territories" label="Territorio"/>
                <AutocompleteArrayInput
                    label="Países"
                    source="countries"
                    choices={this.state.countries}
                    sorteable={false}
                />
                <CatalogFilter source="theme" reference="themes" label="Tema"/>
                <CatalogFilter source="subtheme" reference="subthemes" label="Subtema"/>
                <CatalogFilter source="type" reference="types" label="Tipo"/>
                <CatalogFilter source="scope" reference="scopes" label="Ámbito"/>
                <CatalogFilter source="stage" reference="etapas" label="Etapa"/>
                <CatalogFilter source="term" reference="terms" label="Plazo"/>
                <CatalogFilter source="source" reference="sources" label="Fuente"/>
                <CatalogFilter source="funding_source" reference="financiadores-estudios" label="Financiamiento"/>
                <NumberInput source="total_investment_min" label="Inversión mínima"/>
                <NumberInput source="total_investment_max" label="Inversión máxima"/>
                <SelectInput
                    source="publication_status"
                    label="Estado de publicación"
                    choices={publicationStatusChoices}
                />
            </Filter>
        );
    }
}

const PostPagination = props => <Pagination rowsPerPageOptions={[50, 100]} {...props} />;

const names = items => (items || []).map(item => item.name).join(', ');

const exporter = acciones => {
    try {
        const rows = acciones.map(a => ({
            Codigo: a.code,
            Nombre: a.name,
            Territorios: names(a.territories),
            Paises: a.countriesFormatted,
            Temas: names(a.themes),
            Subtemas: names(a.subthemes),
            Tipos: names(a.types),
            Ambitos: names(a.scopes),
            Etapa: a.stage ? a.stage.name : '',
            Plazo: a.term ? a.term.name : '',
            Fuente: a.source ? a.source.name : '',
            Responsables: (a.responsibles || []).join(', '),
            Inversion_total: a.totalInvestmentFormatted,
            Publicacion: a.publicationStatus
        }));
        downloadCSV(parse(rows), 'Acciones');
    } catch (e) {
        console.error('Export error:', e);
    }
};

const BulkActions = props => (
    <Fragment>
        <BulkDeleteButton undoable={false} {...props} />
    </Fragment>
);

function AccionList(props) {
    const dateFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    };

    return (
        <>
            <List
                {...props}
                bulkActionButtons={<BulkActions/>}
                exporter={exporter}
                filters={<ActionFilter/>}
                pagination={<PostPagination/>}
                perPage={50}
            >
                <CustomDatagrid rowClick="show">
                    <TextField source="id" sortBy="codigo"/>
                    <TextField source="name" label="Nombre" sortBy="nombre"/>
                    <FunctionField label="Territorios" render={record => names(record.territories)}/>
                    <TextField source="countriesFormatted" label="Países" sortBy={'paises_string'}/>
                    <DateField source="createdAt" showTime locales={'es-AR'} options={dateFormatOptions}/>
                    <DateField source="updatedAt" showTime locales={'es-AR'} options={dateFormatOptions}/>
                    <TextField style={{textAlign: 'right'}} source="totalInvestmentFormatted" sortBy={'inversion_estimada'}/>
                    <FunctionField
                        label="Publicación"
                        render={record => {
                            const choice = publicationStatusChoices.find(c => c.id === record.publicationStatus);
                            return choice ? choice.id === 'published' ? 'Publicado' : 'No Publicado' : '';
                        }}
                    />
                </CustomDatagrid>
            </List>
        </>
    );
}

export default translate(AccionList);
